export const css = {
    root: '_1KyH0AvW',
    header: '_3bJMHcPw',
    confirm: '_1hk5SQAk',
    questionWrapper: '_18hTbgkx',
    submit: '_3WZ3rnQ4',
    required: '_16y54jaR',
    ' _key': 'landing-page/survey'
};
export default css;
